import React from 'react';
import Title from '../../components/Title';
import FeatureList from '../../components/FeatureList';
import { MdOutlineCreditScore, MdOutlineNoCrash, MdOutlineElectricCar } from 'react-icons/md';
import hero3Desktop from './assets/hero3-desktop.png';

const features = [
  {
    icon: MdOutlineCreditScore,
    title: 'Agilize o pagamento',
    description: 'Ative o pagamento automático usando sua tag ou cartão de crédito',
  },
  {
    icon: MdOutlineElectricCar,
    title: 'Recarga de carros elétricos',
    description: 'Recarregue seu carro elétrico durante seu passeio no shopping',
  },
  {
    icon: MdOutlineNoCrash,
    title: 'Gratuidade em academias e mercados*',
    description: 'Utilize o Ticket Virtual para obter isenção de estacionamento em academias e mercados do shopping',
    disclaimer: '*Consulte as condições de cada estabelecimento',
  },
];

const FeaturesSection = () => (
  <section className="bg-white py-8 md:py-20" id="estacionamento">
    <div className="max-w-[1300px] w-full px-5 mx-auto">
      <div className="flex justify-center mb-12 items-start flex-col-reverse lg:flex-row">
        <div className="flex flex-col">
          <Title className="text-center lg:text-left">Facilite sua experiência em nossos estacionamentos</Title>
          {/* Illustrative image */}

          <FeatureList items={features} />
        </div>
        <img
          src={hero3Desktop}
          alt="Usuária utilizando o app Multi"
          className="max-w-full h-auto mb-4 lg:mb-0 md:max-w-none lg:max-w-[600px] xl:max-w-[800px]"
        />
      </div>
    </div>
  </section>
);

export default FeaturesSection;
